import { useEffect, useState } from 'react'
import { FaTelegramPlane } from 'react-icons/fa'
import { botLink } from './BotLink'

export default function Connect({ className = '' }) {
  const [copied, setCopied] = useState(false)
  const [qrDataUrl, setQrDataUrl] = useState(null)

  useEffect(() => {
    let alive = true
    ;(async () => {
      try {
        const dataUrl = await QRCode.toDataURL(botLink, {
          errorCorrectionLevel: 'M',
          margin: 0,
          width: 160,
          scale: 4,
          color: { dark: '#000000', light: '#00000000' },
        })
        if (alive) setQrDataUrl(dataUrl)
      } catch {
        // QR необязателен: если не сгенерился — просто скрываем
      }
    })()
    return () => {
      alive = false
    }
  }, [])

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(botLink)
      setCopied(true)
      setTimeout(() => setCopied(false), 1400)
    } catch {
      // Fallback: открываем модальное окно/alert как крайний случай
      alert(botLink)
    }
  }

  return (
    <section
      className={`relative ${className}`}
      aria-labelledby="connect-title"
    >
      <div className="mx-auto max-w-5xl rounded-3xl border border-slate-200 bg-gradient-to-br from-white via-white to-sky-50/70 shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-8 p-5 sm:p-8">
          {/* Левая колонка: текст */}
          <div className="flex flex-col justify-center">
            <p className="text-slate-700">
              Откройте Telegram — мы выйдем на связь{' '}
              <span className="whitespace-nowrap font-medium text-slate-900">
                в течение одного рабочего дня
              </span>{' '}
              и подберём лучший сценарий подключения.
            </p>

            <ul className="mt-4 space-y-2 text-sm text-slate-600 list-disc list-inside">
              <li>Подключение без интеграционного ада</li>
              <li>Готовые сценарии под ивенты и промо</li>
              <li>Поддержка и онбординг</li>
            </ul>
          </div>

          {/* Правая колонка: CTA + QR */}
          <div className="flex flex-col items-center justify-center gap-4">
            <a
              href={botLink}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center justify-center w-full sm:w-auto gap-3 px-6 py-3 rounded-xl font-semibold text-white bg-gradient-to-r from-sky-500 to-cyan-500 shadow-lg hover:shadow-xl active:shadow-md transition-shadow focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400"
              aria-label="Открыть бота в Telegram"
            >
              <FaTelegramPlane className="w-5 h-5 transition-transform group-hover:-translate-y-px" />
              Открыть в Telegram
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
